<template>
  <card-seplag titulo="Auditoria Declarações">
    <div class="p-col-12 container">
      <div class="container-cabecalho">
        <div>
          <span class="label-info">Órgão: </span>
          <span>{{ userOrgao }}</span>
        </div>

        <div>
          <span class="label-info">Usuário: </span>
          <span>{{ userName }}</span>
        </div>
      </div>

      <div class="container-filtro">
        <Rotulo nome="Exercício" cols="12 2">
          <Dropdown
            class="classe-dropdown"
            v-model="filtroTabelaPessoa.idenExercicio"
            :options="dropdownExercicio"
            optionLabel="ano"
            optionValue="idenExercicio"
            @change="limparCampos()"
          />
        </Rotulo>

        <Rotulo nome="Digite CPF, matrícula ou nome" cols="12 6">
          <AutoComplete
            v-model="textoBusca"
            :suggestions="resultadoBusca"
            @complete="searchPessoaExercicio($event)"
            @item-select="selecionarPessoaExercicio($event)"
            field="nomePessoa"
          >
            <template #item="slotProps">
              <div>
                <b>CPF/Matricula:</b> {{ slotProps.item.cpfFormatado }}/{{
                  slotProps.item.numrMatricula
                }}
                - <b>Nome: </b>{{ slotProps.item.nomePessoa }}
              </div>
            </template>
          </AutoComplete>
        </Rotulo>

        <Button
          icon="pi pi-search"
          :disabled="idenPessoaExercicio == null"
          @click="searchAudit"
          label="buscar"
          class="classe-buttom"
        />
      </div>
    </div>

    <table-seplag
      :dados.sync="dados.content"
      :hasExibirCabecalho="dados.content.length > 0"
      :campos="camposTabelaAuditoria"
      :paginacao="true"
      :totalRegistro.sync="dados.totalElements"
      :onSearchPaginacao="onSearchPaginacao"
      :linhas="50"
    >
      <template #buttonsHeader v-if="dados.content.length > 0">
        <div style="display: flex">
          <Button
            @click="exportExcel"
            label="Excel"
            icon="pi pi-external-link"
            class="p-button-raised"
            style="
              margin: 5px;
              background: #107c41;
              border-color: rgb(1 114 52);
            "
          />
          <Button
            @click="exportPDF"
            label="PDF"
            icon="pi pi-external-link"
            class="p-button-raised"
            style="margin: 5px; background: #c5031d; border-color: #b70019"
          />
        </div>
      </template>
    </table-seplag>

    <CardExibirPDF
      :tamanhoTela="'85,vw'"
      :alturaTela="'120,vh'"
      :pdfElement="dadosRelatorioBase64"
      v-model="isExibirPDF"
      :tituloTela="tituloPDF"
      v-if="isExibirPDF"
    />
  </card-seplag>
</template>

<script >
import CardSeplag from "@/template/CardSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import { baseApiUrl } from "@/config/global";
import Rotulo from "@/template/RotuloSeplag.vue";
import download from 'downloadjs';
import CardExibirPDF from "@/template/CardExibirPDF";

export default {
  name: "auditoria",
  components: { CardSeplag, TableSeplag, Rotulo, CardExibirPDF },

  data: function () {
    return {
      dropdownExercicio: null,
      anoAtual: new Date().getFullYear(),
      userName: "",
      userOrgao: "",
      matriculaUsuario: null,
      idenPessoaUsuario: null,
      formTitulo: "",
      isVisibleForm: false,
      idenPessoaExercicio: null,
      resultadoBusca: null,
      camposTabelaPessoa: [
        { nome: "cpf", titulo: "CPF" },
        { nome: "nome", titulo: "Nome" },
      ],
      filtroTabelaPessoa: {
        idenExercicio: null,
        textoPesquisa: null,
        tipoPesquisa: { codTipo: "N", descTipo: "Nome" },
      },
      dados: {
        content: [],
      },
      camposTabelaAuditoria: [
        { nome: "dataOperacaoFormatada", titulo: "Data/Hora" },
        { nome: "endrIpCliente", titulo: "IP" },
        { nome: "tabela", titulo: "Tela" },
        { nome: "acao", titulo: "Ação" },
        { nome: "informacaoDetalhe", titulo: "Informação/Detalhe" },
      ],
      dropdownTipoPesquisa: [
        { codTipo: "N", descTipo: "Nome" },
        { codTipo: "M", descTipo: "Matrícula" },
        { codTipo: "C", descTipo: "CPF" },
      ],
      nomesFiltrados: [],
      textoBusca: null,
      isExibirPDF: false,
      tituloPDF: " ",
      dadosRelatorioBase64: "",
    };
  },
  methods: {
    carregarDados() {
      this.matriculaUsuario =
        this.$store.getters.getUser.contaAcesso.pessoa.servidor.numrMatricula;
      this.idenPessoaUsuario =
        this.$store.getters.getUser.contaAcesso.pessoa.idenPessoa;
      this.userName = this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa;
      this.userOrgao =
        this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor[0].descOrgao;
      this.listarExercicios();
    },

    limparCampos() {
      this.idenPessoaExercicio = null;
      this.dados.content = [];
      this.textoBusca = "";
    },
    listarExercicios() {
      this.$http
        .get(`${baseApiUrl}/exercicios/periodo/2021/${this.anoAtual}`)
        .then((res) => {
          this.dropdownExercicio = res.data;
          this.filtroTabelaPessoa.idenExercicio = res.data[0].idenExercicio;
        });
    },

    pesquisarLogAuditoria() {
      this.$http
        .get(
          `${baseApiUrl}/auditorias/pessoaexercicio/${this.idenPessoaExercicio}?size=50&page=0`
        )
        .then((res) => {
          this.dados = res.data;
        });
    },

    pesquisarPessoaExercicio() {
      this.idenPessoaExercicio = null;

      let qtdCaracteres = this.isNumber(this.textoBusca) ? 2 : 5;
      if (this.textoBusca.length >= qtdCaracteres) {
        this.$http
          .post(
            `${baseApiUrl}/pessoaexercicios/buscarPorNomeOuCpfOuMatricula/${this.filtroTabelaPessoa.idenExercicio}`,
            this.textoBusca
          )
          .then((res) => {
            this.resultadoBusca = res.data;
          });
      }
    },
    isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    selecionarPessoaExercicio(evento) {
      this.dados.content = [];
      this.idenPessoaExercicio = evento.value.idenPessoaExercicio;
    },

    verificaVazioPessoa() {
      Object.keys(this.filtroTabelaPessoa).forEach((item) => {
        this.filtroTabelaPessoa[item] =
          this.filtroTabelaPessoa[item] === ""
            ? null
            : this.filtroTabelaPessoa[item] == "todos"
            ? null
            : this.filtroTabelaPessoa[item];
      });
    },

    searchAudit() {
      this.pesquisarLogAuditoria();
    },

    searchPessoaExercicio() {
      this.pesquisarPessoaExercicio();
    },

    onSearchPaginacao(rows, page) {
      this.$http
        .get(
          `${baseApiUrl}/auditorias/pessoaexercicio/${this.idenPessoaExercicio}?size=${rows}&page=${page}`,
          JSON.stringify(this.idenPessoaExercicio)
        )
        .then((res) => {
          this.dados = res.data;
          this.totalRegistro = res.data.totalElements;
        });
    },

    onSearchPaginacaoPessoa(rows, page) {
      this.verificaVazio();
      this.$http
        .post(
          `${baseApiUrl}/pessoaexercicios/pesquisaud?size=${rows}&page=${page}`,
          JSON.stringify(this.filtroTabelaPessoa)
        )
        .then((res) => {
          this.dadosPessoa = res.data;
          this.totalRegistro = res.data.totalElements;
          this.reorganizarDadosPessoa();
        });
    },

    reorganizarDados() {
      this.dados.content = this.dados.content.map((item) => {
        let valueReturn = {
          idenPessoaExercicio: item.idenPessoaExercicio,
          dataHora: item.dataHora,
          ip: item.ip,
          tela: item.tabela,
          acao: item.acao,
          informacaoDetalhe: item.informacaoDetalhe,
        };

        return valueReturn;
      });
    },

    reorganizarDadosPessoa() {
      this.dados.content = this.dados.content.map((item) => {
        let valueReturn = {
          idenPessoaExercicio: item.idenPessoaExercicio,
          cpf: item.cpf,
          nome: item.nome,
        };

        return valueReturn;
      });
    },

    exportExcel() {
      let jsonPost = {
        idenPessoaExercicio: this.idenPessoaExercicio,
        tipoRelatorio: "EXCEL",  
        usuarioLogado: this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,     
        orgaoLotacao: this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor[0].descOrgao
      };

      this.$http
        .post(
          `${baseApiUrl}/auditorias/relatorio/auditoria`,
          JSON.stringify(jsonPost)
        )
        .then((res) => {
          download(
            `data:application/excel;base64,${res.data.dadosRelatorioBase64}`,
            `${res.data.nomeArquivo}`,
            "application/excel"
          );
        })
    },
    exportPDF() {
       let jsonPost = {
        idenPessoaExercicio: this.idenPessoaExercicio,
        tipoRelatorio: "PDF",  
        usuarioLogado: this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,     
        orgaoLotacao: this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor[0].descOrgao
      };

      this.$http
        .post(
          `${baseApiUrl}/auditorias/relatorio/auditoria`,
          JSON.stringify(jsonPost)
        )
        .then((res) => {
          this.dadosRelatorioBase64 = `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`;
          this.isExibirPDF = true;
        });
    },
  },

  mounted() {
    this.carregarDados();
  },
};
</script>

<style scoped>
/* .classe-dropdown{
    margin-right: 0.5rem;
  } */

/* .classe-input{
     max-width: 20rem; 
    margin-right: 0.5rem;
     margin: auto 0.5rem; 
  } */

.label-info {
  font-size: 1rem;
  font-weight: bold;
  margin-right: 0.4rem;
}

.container-cabecalho {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.container-cabecalho > div {
  margin-bottom: 0.9rem;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.button-acoes > button {
  margin: 0.3rem auto;
}

.container-filtro {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.classe-buttom {
  max-width: 10rem;
  max-height: 40px;
  margin-top: 14px;
}

@media screen and (max-width: 425px) {
  .classe-input {
    margin-bottom: 0.5rem;
    /* margin: auto 0.5rem; */
  }

  .container-filtro {
    display: flex;
    flex-direction: column;
  }

  .classe-dropdown {
    margin-bottom: 0.5rem;
  }

  .classe-buttom {
    max-width: 100%;
  }
}
</style>

<style>
.column-acoes {
  width: 20rem;
}

.button-icon {
  font-size: 1.5rem;
}

@media screen and (min-width: 481px) and (max-width: 1080px) {
  .column-acoes {
    width: 5rem;
  }

  .button-acoes > button > span {
    display: none;
  }
  .button-acoes > button {
    padding: 0.5rem 0.69rem;
  }
  .button-icon {
    font-size: 1.5rem;
  }
}
</style>